import { render } from "./KindAnime.vue?vue&type=template&id=5db071ea"
import script from "./KindAnime.vue?vue&type=script&lang=js"
export * from "./KindAnime.vue?vue&type=script&lang=js"

import "./KindAnime.vue?vue&type=style&index=0&id=5db071ea&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__